const FullScreenIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.02083 2.1875H11.8125V5.97917M8.02083 5.97917L11.3613 2.63867M5.97917 8.02083L2.63867 11.3613M2.1875 8.02083V11.8125H5.97917"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default FullScreenIcon
